export default __webpack_public_path__ + "static/illustration2-a0ca3759e31aeec58dd74f36fe2c541e.png";